import { useSelector } from 'react-redux';
import { selectCustomAppendices } from '../../selectors';

export const useCustomAppendices = () => {
  const customAppendices = useSelector(selectCustomAppendices);

  return customAppendices;
};
